export default "__VITE_ASSET__BLxqzSFz__"